module.exports = __webpack_public_path__ + "img/favion.8309811e.svg";